import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";

@Component({
    selector: "app-categorias",
    templateUrl: "./categorias.component.html",
    styleUrls: ["./categorias.component.scss"],
})
export class CategoriasComponent implements OnInit {
    @Input() categorias: CategoriaDTO[];
    @Output() buscarServicios: EventEmitter<number> = new EventEmitter();
    treeControl = new NestedTreeControl<CategoriaDTO>((node) => node.grupos);
    dataSource = new MatTreeNestedDataSource<CategoriaDTO>();

    constructor() {}

    ngOnInit() {
        this.dataSource.data = this.categorias;
        //console.log(this.categorias);
    }

    hasChild = (_: number, node: CategoriaDTO) =>
        //!!node.children && node.children.length > 0;
        !!node.grupos && node.grupos.length > 0;

    buscar(node) {
        //console.log(node);
        this.buscarServicios.emit(node);
    }
}
